
    import { Component, Vue } from 'vue-property-decorator';
    import { ApiRepository } from '@/api';
    import InputText from '@/components/form/Input-text.vue';
    import Layout from '@/components/layout/Layout.vue';


    @Component({
        components: {
            InputText,
            Layout
        },
    })
    export default class ChangePassword extends Vue {
        private oldPassword = '';
        private newPassword = '';
        private newPasswordConfimation = '';

        private async onSubmit(event: any) {
            event.preventDefault();
            const token = this.$route.params.token;

            this.$validator.validate().then(async (valid) => {
                if (valid && this.newPassword === this.newPasswordConfimation) {
                    await ApiRepository.postChangePassword(this.oldPassword, this.newPassword, this.newPasswordConfimation);
                    this.$router.push('/')
                } else {
                    this.$notify({group: 'auth', type: 'warning', text: 'Heslá sa nezhodujú'});
                }
            });
        }
    }
